import { render, staticRenderFns } from "./GridBox.vue?vue&type=template&id=146819ca&scoped=true"
import script from "./GridBox.vue?vue&type=script&lang=js"
export * from "./GridBox.vue?vue&type=script&lang=js"
import style0 from "./GridBox.vue?vue&type=style&index=0&id=146819ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146819ca",
  null
  
)

export default component.exports